module.exports = __webpack_public_path__ + "img/boton_seleccionar_todo.3fc8752f.svg";